import _ from 'lodash';
import { adapi, permissions } from '~';
import { mapActions, mapState } from 'vuex';
import CampaignSummary from '@/components/rabbit/campaign-summary/CampaignSummary.vue';
import CampaignWorkflow from '@/components/rabbit/campaign-workflow/CampaignWorkflow.vue';
import CampaignStep from '@/components/rabbit/campaign-step/CampaignStep.vue';
import TriggerNotification from '@/components/trigger-notification/TriggerNotification.vue';
import { NOTIFICATION_EVENTS } from '@/util/constants';


export default {
  components: {
    TriggerNotification,
    'campaign-step': CampaignStep,
    'campaign-summary': CampaignSummary,
    'campaign-workflow': CampaignWorkflow,
  },
  data() {
    return {
      NOTIFICATION_EVENTS,
      customAudienceOptOut: false,
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('campaign', {
      current: 'current',
      error: 'error',
    }),
    permissions() {
      return permissions.getPermissions(this.current);
    },
    canViewProgress() {
      return permissions.canGlobal(this.user, 'Campaign', ['viewProgress']);
    },
    canOptOut() {
      return this.permissions.includes('toggleCustomAudienceOptOut');
    },
    canSuspendCampaign() {
      return this.permissions.includes('suspend');
    },
    canResumeCampaign() {
      return this.permissions.includes('resume');
    },
  },
  methods: {
    ...mapActions('campaign', ['reloadCampaign']),
    toggleCustomAudience() {
      return adapi.post(`campaigns/${this.current.code}/custom-audience/toggle`)
        .then(() => {
          this.$toast.success({ message: this.$t('pos.campaign.toggle-success') });
          this.customAudienceOptOut = true;
        })
        .catch(error => {
          this.$toast.error({ message: error });
        });
    },
    suspendCampaign() {
      return adapi.post(`campaigns/${this.current.code}/suspend`)
        .then(() => {
          this.$toast.success({ message: this.$t('pos.campaign.campaign-suspended-text') });
        })
        .then(() => this.reloadCampaign())
        .catch(error => {
          this.$toast.error({ message: String(error) });
        });
    },
    resumeCampaign() {
      return adapi.post(`campaigns/${this.current.code}/resume`)
        .then(() => {
          this.$toast.success({ message: this.$t('pos.campaign.campaign-resume-text') });
        })
        .then(() => this.reloadCampaign())
        .catch(error => {
          this.$toast.error({ message: String(error) });
        });
    },
  },
  mounted() {
    if (this.current.details) {
      const customAudienceOptOut = this.current.details.filter(arr => arr.name === 'customAudienceOptOut')[0];
      this.customAudienceOptOut = _.get(customAudienceOptOut, 'value', '0') === '1';
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/rabbit/campaign/Campaign.js